module.exports = __webpack_public_path__ + "img/balance_tip.9c8cb4be.png";